"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = isObject;
exports.isDefined = isDefined;
exports.setTargetNode = setTargetNode;
exports.updateCoordinates = updateCoordinates;
exports.getAnnotationPayload = getAnnotationPayload;
exports.getCommentPayload = getCommentPayload;
exports.PRIMARY_LINKREL = exports.PL = exports.STATUS = exports.MOTIVATIONS = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _Client = _interopRequireDefault(require("../Client"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var MOTIVATIONS = {
  COMMENT: 'commenting',
  REPLY: 'replying'
};
exports.MOTIVATIONS = MOTIVATIONS;
var STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved'
};
exports.STATUS = STATUS;
var COLLAB_NS = 'collab';
var PL = {
  P_EMBEDDED: '_embedded',
  P_PRIMARY_URL: 'http://ns.adobe.com/adobecloud/rel/primary',
  P_BODY: "".concat(COLLAB_NS, ":body"),
  P_MOTIVATION: "".concat(COLLAB_NS, ":motivation"),
  P_TARGET: "".concat(COLLAB_NS, ":target"),
  P_SOURCE: "".concat(COLLAB_NS, ":source"),
  P_SELECTOR: "".concat(COLLAB_NS, ":selector"),
  P_PRIMARY_SELECTOR: "".concat(COLLAB_NS, ":primarySelector"),
  P_TYPE: "".concat(COLLAB_NS, ":type"),
  P_ID: "".concat(COLLAB_NS, ":id"),
  P_INDEX: "".concat(COLLAB_NS, ":index"),
  P_NOTEX: "".concat(COLLAB_NS, ":noteX"),
  P_NOTEY: "".concat(COLLAB_NS, ":noteY"),
  P_CREATOR: "".concat(COLLAB_NS, ":creator"),
  P_ANNOTDATA: "".concat(COLLAB_NS, ":annotCollectionData"),
  P_STATUS: "".concat(COLLAB_NS, ":status"),
  P_MENTIONS: "".concat(COLLAB_NS, ":mentions"),
  P_REFINEDBY: "".concat(COLLAB_NS, ":refinedBy"),
  P_LEFTOFFSET: "".concat(COLLAB_NS, ":leftOffset"),
  P_TOPOFFSET: "".concat(COLLAB_NS, ":topOffset"),
  P_STARTSTRUCTELEM: "".concat(COLLAB_NS, ":startStructElem"),
  P_BOUNDINGBOX: "".concat(COLLAB_NS, ":boundingBox"),
  P_INKLIST: "".concat(COLLAB_NS, ":inkList"),
  P_QUADPOINTS: "".concat(COLLAB_NS, ":quadPoints"),
  P_ANNOT_STYLE: "".concat(COLLAB_NS, ":annotationStyle"),
  P_ANNOT_STROKECOLOR: "".concat(COLLAB_NS, ":strokeColor"),
  P_ANNOT_STROKEWIDTH: "".concat(COLLAB_NS, ":strokeWidth"),
  P_ANNOT_OPACITY: "".concat(COLLAB_NS, ":opacity")
};
exports.PL = PL;
var PRIMARY_LINKREL = 'http://ns.adobe.com/adobecloud/rel/primary';
/**
 * Checks for an object over primitives.
 *
 * @param   {object}  val  Value to test
 *
 * @return  {boolean}       true if an object
 */

exports.PRIMARY_LINKREL = PRIMARY_LINKREL;

function isObject(val) {
  if (val === null) {
    return false;
  }

  return typeof val === 'function' || _typeof(val) === 'object';
}
/**
 * Checked for a value.
 *
 * @param   {any}  value  Any value
 *
 * @return  {boolean}         true if defined
 */


function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 * Sets the targets nodeId or nodeIndex value;
 *
 * @param   {json}  annotationBody  annotationBody
 * @param   {json}  nodeId          object defines either id or index
 *
 * @return  {json}                  annotationBody
 */


function setTargetNode(annotationBody, nodeId) {
  if (isDefined(nodeId) && annotationBody) {
    var nodeObject = {};

    if (_Client["default"].instance.useNodeIndex) {
      nodeObject.index = nodeId;
    } else {
      nodeObject.id = nodeId;
    }

    annotationBody.target = {
      selector: {
        type: 'AdobeAnnoSelector',
        subtype: 'node',
        node: nodeObject
      }
    };
  }

  return annotationBody;
}
/**
 * Returns an array of points for a given shape.
 *
 * @param   {json}  coordinates json payload for noteX,Y and sectionId (optional)
 * @return  {object} inkList array
 */


function getShapeInkList(coordinates) {
  var inkList = [];
  coordinates.inkList.forEach(function (curShape) {
    if (curShape.length) {
      var shapeInkList = [];
      curShape.forEach(function (coordinate) {
        shapeInkList.push(coordinate.x, coordinate.y);
      });
      inkList.push(shapeInkList);
    }
  });
  return inkList;
}
/**
 * Returns an array of points for a given shape.
 *
 * @param   {json}  coordinates json payload for noteX,Y and sectionId (optional)
 * @return  {object} quadList array
 */


function getDrawInkList(coordinates) {
  var quadPointsFull = [];
  coordinates.inkList.forEach(function (curQuad) {
    if (curQuad.length) {
      var quadPoints = curQuad.reduce(function (acc, point) {
        return acc.concat(point.x, point.y);
      }, []);
      quadPointsFull = quadPointsFull.concat(quadPoints);
    }
  });
  return quadPointsFull;
}
/**
 * Legacy API processing of payload for adding coordinate json payload.
 *
 * @param   {json}  annotationBody to be updated
 * @param   {json}  coordinates optional coordinates
 * @param   {bool}  nullify true clears old values
 * @return  {json} Updated annotation body
 */


function updateCoordinates(annotationBody, coordinates, nullify) {
  // If nullifying, the annotationBody is not new.  Certain values must
  // be reset or cleared prior to possible updates found in 'coordinates' param.
  //
  // The nullify portion is based on what was 'getRedhawkFormattedObject()'.
  if (nullify) {
    if (annotationBody.motivation === MOTIVATIONS.REPLY) {
      return annotationBody;
    } // Prefetch existing values.


    var subtype = (0, _get2["default"])(annotationBody, 'target.selector.subtype');
    var sectionId = (0, _get2["default"])(annotationBody, 'target.selector.sectionId');

    if (subtype === 'highlight' || subtype === 'replace' || subtype === 'strikethrough') {
      delete annotationBody.target.selector.inkList;

      if (subtype === 'strikethrough') {
        // Reset.
        annotationBody.target.selector.subtype = 'strikeout';
      }

      if (sectionId) {
        // Reset.
        annotationBody.target.selector.refinedBy = {
          type: 'AdobeDynamicViewSelector',
          startStructId: sectionId
        };
        delete annotationBody.target.selector.sectionId;
      }
    } else if (subtype === 'shape') {
      // Reset.
      annotationBody.target.selector.inkList = getShapeInkList(annotationBody.target.selector);

      if (sectionId) {
        annotationBody.target.selector.refinedBy = {
          type: 'AdobeDynamicViewSelector',
          startStructId: sectionId
        };
        delete annotationBody.target.selector.sectionId;
      }
    } else if (subtype === 'note') {
      if (sectionId) {
        var noteX = (0, _get2["default"])(annotationBody, 'target.selector.noteX');
        var noteY = (0, _get2["default"])(annotationBody, 'target.selector.noteY'); // Reset.

        annotationBody.target.selector.refinedBy = {
          type: 'AdobeDynamicViewSelector',
          leftOffset: noteX,
          topOffset: noteY,
          startStructId: sectionId
        };
        delete annotationBody.target.selector.noteX;
        delete annotationBody.target.selector.noteY;
        delete annotationBody.target.selector.sectionId;
      } else {
        annotationBody.target.selector.refinedBy = null;
      }
    }

    var clientAddedNode = (0, _get2["default"])(annotationBody, 'target.selector.node.clientAddedNode');

    if (clientAddedNode) {
      delete annotationBody.target.selector.node.clientAddedNode;

      if (annotationBody.creator.id.indexOf(_Client["default"].instance.userId) === -1) {
        delete annotationBody.target.selector;
      }
    }

    var clientAdjustedIndexToId = (0, _get2["default"])(annotationBody, 'target.selector.node.clientAdjustedIndexToId');

    if (clientAdjustedIndexToId) {
      var nodeIdxValue = annotationBody.target.selector.node.id;
      annotationBody.target.selector.node.index = nodeIdxValue;
      delete annotationBody.target.selector.node.id;
      delete annotationBody.target.selector.node.clientAdjustedIndexToId;

      if (subtype === 'highlight' || subtype === 'replace' || subtype === 'strikethrough') {
        if (annotationBody.target.selector.node.indices && annotationBody.target.selector.node.indices.length) {
          var indicies = (0, _lodash["default"])(annotationBody.target.selector.node.indices);
          annotationBody.target.selector.node.indices = indicies.map(function (indice) {
            indice.index = nodeIdxValue;
            return indice;
          });
        }
      }
    }
  }

  if (coordinates) {
    // Now updates, or new values.
    if (coordinates.subtype === 'highlight' || coordinates.subtype === 'strikethrough') {
      annotationBody.target.selector = Object.assign({}, annotationBody.target.selector, {
        subtype: coordinates.subtype === 'highlight' ? 'highlight' : 'strikeout',
        opacity: coordinates.opacity || 0.4,
        strokeColor: coordinates.strokeColor || '#000000',
        boundingBox: coordinates.boundingBox
      });
      annotationBody.target.selector.quadPoints = getDrawInkList(coordinates);

      if (coordinates.sectionId) {
        annotationBody.target.selector.refinedBy = {
          type: 'AdobeDynamicViewSelector',
          startStructId: coordinates.sectionId
        };
      }
    } else if (coordinates.subtype === 'replace') {
      annotationBody.target.selector = Object.assign({}, annotationBody.target.selector, {
        subtype: 'replace',
        opacity: coordinates.opacity || 0.4,
        strokeColor: coordinates.strokeColor || '#000000',
        boundingBox: coordinates.boundingBox,
        rect: coordinates.boundingBox
      });
      annotationBody.target.selector.quadPoints = getDrawInkList(coordinates);

      if (coordinates.sectionId) {
        annotationBody.target.selector.refinedBy = {
          type: 'AdobeDynamicViewSelector',
          startStructId: coordinates.sectionId
        };
      }
    } else if (coordinates.subtype === 'shape') {
      annotationBody.target.selector = Object.assign({}, annotationBody.target.selector, {
        subtype: 'shape',
        opacity: coordinates.opacity || 1,
        strokeWidth: coordinates.strokeWidth || 5,
        strokeColor: coordinates.strokeColor || '#000000',
        boundingBox: coordinates.boundingBox
      });
      annotationBody.target.selector.inkList = getShapeInkList(coordinates);

      if (coordinates.sectionId) {
        annotationBody.target.selector.refinedBy = {
          type: 'AdobeDynamicViewSelector',
          startStructId: coordinates.sectionId
        };
      }
    } else if (coordinates.subtype === 'insert') {
      annotationBody.target.selector = Object.assign({}, annotationBody.target.selector, {
        subtype: 'insert',
        boundingBox: coordinates.boundingBox,
        rect: coordinates.boundingBox,
        strokeColor: coordinates.strokeColor || '#000000',
        noteX: coordinates.noteX,
        noteY: coordinates.noteY
      });
    } else {
      annotationBody.target.selector.subtype = 'note';

      if (coordinates.sectionId) {
        annotationBody.target.selector.refinedBy = {
          type: 'AdobeDynamicViewSelector',
          leftOffset: coordinates.noteX,
          topOffset: coordinates.noteY,
          startStructId: coordinates.sectionId
        };
        annotationBody.target.selector.strokeColor = coordinates.strokeColor;
      } else {
        annotationBody.target.selector.noteX = coordinates.noteX;
        annotationBody.target.selector.noteY = coordinates.noteY;
        annotationBody.target.selector.strokeColor = coordinates.strokeColor;
      }
    }
  }

  return annotationBody;
}
/**
 * Produces ACP payload for mentions.
 *
 * @param   {json[]}  mentions json array of mentions
 *
 * @return  {json[]}  ACP payload
 */


function getACPMentions(mentions) {
  var acpMentions = [];

  if (mentions) {
    mentions.forEach(function (mention) {
      acpMentions.push({
        'xdm:displayName': mention.name,
        'xdm:id': mention.id.replace('urn:uuid:', ''),
        'xdm:type': mention.type
      });
    });
  }

  return acpMentions;
}
/**
 * Produces ACP payload for target.
 * Note that this portion of payload is re-created.
 *
 * @param   {string}  id           id of asset
 * @param   {string}  nodeId       node id (optional)
 * @param   {json}  coordinates    json payload for noteX,Y and sectionId (optional)
 *
 * @return  {json}               json payload describing targets
 */


function getACPTarget(id, nodeId, coordinates) {
  // A limited subset of xdm
  var target = _defineProperty({}, PL.P_SOURCE, id);

  if (isDefined(nodeId)) {
    var _target$PL$P_SELECTOR;

    target[PL.P_SELECTOR] = (_target$PL$P_SELECTOR = {}, _defineProperty(_target$PL$P_SELECTOR, PL.P_TYPE, 'node'), _defineProperty(_target$PL$P_SELECTOR, PL.P_PRIMARY_SELECTOR, [_defineProperty({}, PL.P_TYPE, 'NodeSelector')]), _target$PL$P_SELECTOR); // Allow for either passing the default primitive id (backwards compatible),
    // or an object containing either { id: xxx } or { index: yyy }
    // This allows one to create a comment using a node id or index without changing the api comment() api.

    var nodeValue = nodeId;

    if (isObject(nodeId)) {
      nodeValue = nodeId.index ? nodeId.index : nodeId.id;
    } // If useNodeIndex specified, or explicit object type defines an index..


    if (_Client["default"].instance.useNodeIndex || isObject(nodeId) && isDefined(nodeId.index)) {
      target[PL.P_SELECTOR][PL.P_PRIMARY_SELECTOR][0][PL.P_INDEX] = nodeValue;
    } else {
      if (typeof nodeValue === 'number') {
        throw new Error('Expecting nodeId should be a string, or useNodeIndex should be true');
      }

      target[PL.P_SELECTOR][PL.P_PRIMARY_SELECTOR][0][PL.P_ID] = nodeValue;
    }
  }

  if (coordinates) {
    // If no nodeId default to doc-level indexing.
    if (!target[PL.P_SELECTOR]) {
      target[PL.P_SELECTOR] = _defineProperty({}, PL.P_PRIMARY_SELECTOR, [_defineProperty({}, PL.P_INDEX, 0)]);
    }

    if (!coordinates.subtype || coordinates.subtype === '' || coordinates.subtype === 'note') {
      // Flip to note.
      target[PL.P_SELECTOR][PL.P_TYPE] = 'note'; // No nullify required -- new target created each time.

      if (coordinates.sectionId) {
        var _target$PL$P_SELECTOR3;

        // Only works for node types.  For notes, we're missing extra noteX,Y given
        // structure of current param list provided by this sdk.  It will work
        // in the case of an update (PUT) however.
        target[PL.P_SELECTOR][PL.P_REFINEDBY] = (_target$PL$P_SELECTOR3 = {}, _defineProperty(_target$PL$P_SELECTOR3, PL.P_TYPE, 'PositionSelector'), _defineProperty(_target$PL$P_SELECTOR3, PL.P_LEFTOFFSET, coordinates.noteX), _defineProperty(_target$PL$P_SELECTOR3, PL.P_TOPOFFSET, coordinates.noteY), _defineProperty(_target$PL$P_SELECTOR3, PL.P_STARTSTRUCTELEM, coordinates.sectionId), _target$PL$P_SELECTOR3);
      } else {
        target[PL.P_SELECTOR][PL.P_PRIMARY_SELECTOR][0][PL.P_NOTEX] = coordinates.noteX;
        target[PL.P_SELECTOR][PL.P_PRIMARY_SELECTOR][0][PL.P_NOTEY] = coordinates.noteY;
      }
    } else if (coordinates.subtype === 'shape') {
      var _target$PL$P_ANNOT_ST;

      // Flip to shape.
      target[PL.P_SELECTOR][PL.P_TYPE] = 'shape';
      target[PL.P_SELECTOR][PL.P_PRIMARY_SELECTOR][0][PL.P_BOUNDINGBOX] = coordinates.boundingBox;
      target[PL.P_SELECTOR][PL.P_PRIMARY_SELECTOR][0][PL.P_INKLIST] = getShapeInkList(coordinates);
      target[PL.P_ANNOT_STYLE] = (_target$PL$P_ANNOT_ST = {}, _defineProperty(_target$PL$P_ANNOT_ST, PL.P_ANNOT_STROKECOLOR, coordinates.strokeColor || '#000000'), _defineProperty(_target$PL$P_ANNOT_ST, PL.P_ANNOT_STROKEWIDTH, coordinates.strokeWidth || 5), _defineProperty(_target$PL$P_ANNOT_ST, PL.P_ANNOT_OPACITY, coordinates.opacity || 1), _target$PL$P_ANNOT_ST); // TODO: Verify

      if (coordinates.sectionId) {
        var _target$PL$P_SELECTOR4;

        target[PL.P_SELECTOR][PL.P_REFINEDBY] = (_target$PL$P_SELECTOR4 = {}, _defineProperty(_target$PL$P_SELECTOR4, PL.P_TYPE, 'PositionSelector'), _defineProperty(_target$PL$P_SELECTOR4, PL.P_STARTSTRUCTELEM, coordinates.sectionId), _target$PL$P_SELECTOR4);
      }
    } else if (coordinates.subtype === 'highlight' || coordinates.subtype === 'replace' || coordinates.subtype === 'strikethrough') {
      var _target$PL$P_ANNOT_ST2;

      // Flip to highlight, replace, or strikeout.
      if (coordinates.subtype === 'highlight') {
        target[PL.P_SELECTOR][PL.P_TYPE] = 'highlight';
      } else {
        target[PL.P_SELECTOR][PL.P_TYPE] = coordinates.subtype === 'replace' ? 'replace' : 'strikeout';
      }

      target[PL.P_SELECTOR][PL.P_PRIMARY_SELECTOR][0][PL.P_BOUNDINGBOX] = coordinates.boundingBox;
      target[PL.P_SELECTOR][PL.P_PRIMARY_SELECTOR][0][PL.P_QUADPOINTS] = getDrawInkList(coordinates);
      target[PL.P_ANNOT_STYLE] = (_target$PL$P_ANNOT_ST2 = {}, _defineProperty(_target$PL$P_ANNOT_ST2, PL.P_ANNOT_STROKECOLOR, coordinates.strokeColor || '#000000'), _defineProperty(_target$PL$P_ANNOT_ST2, PL.P_ANNOT_STROKEWIDTH, coordinates.strokeWidth || 1), _defineProperty(_target$PL$P_ANNOT_ST2, PL.P_ANNOT_OPACITY, coordinates.opacity || 0.4), _target$PL$P_ANNOT_ST2); // TODO: Verify

      if (coordinates.sectionId) {
        var _target$PL$P_SELECTOR5;

        target[PL.P_SELECTOR][PL.P_REFINEDBY] = (_target$PL$P_SELECTOR5 = {}, _defineProperty(_target$PL$P_SELECTOR5, PL.P_TYPE, 'PositionSelector'), _defineProperty(_target$PL$P_SELECTOR5, PL.P_STARTSTRUCTELEM, coordinates.sectionId), _target$PL$P_SELECTOR5);
      }
    }
  }

  return target;
}
/**
 * Produces ACP payload for updating an *existing* annotation.
 *
 * @param   {obj}  annotation    existng annotation object
 * @param   {String} nodeIdOverride The id of the node within the asset you wish to reassign the comment to.
 * @param   {bool}  useTarget    if true, adorn target info
 * @param   {json}  coordinates  json payload for noteX,Y and sectionId (optional)
 *
 * @return  {json}               updated annotation payload
 */


function getAnnotationPayload(annotation, nodeIdOverride, useTarget, coordinates) {
  var _payload;

  var payload = (_payload = {}, _defineProperty(_payload, PL.P_STATUS, annotation.status), _defineProperty(_payload, PL.P_BODY, {
    'dc:format': 'text/plain',
    value: annotation.bodyValue
  }), _defineProperty(_payload, PL.P_MENTIONS, getACPMentions(annotation.mentions)), _payload);

  if (useTarget) {
    var nodeValue = null;

    if (isDefined(nodeIdOverride)) {
      nodeValue = nodeIdOverride; // Carry over from CS, look for a client override that forces provided value as index.

      if (_Client["default"].instance.useNodeIndex) {
        nodeValue = {
          index: nodeIdOverride
        };
      } else if (!isObject(nodeIdOverride)) {
        // If an object assume format is extended format { index: xxx } or { id: yyy }
        nodeValue = {
          id: nodeIdOverride
        };
      }
    } else if (annotation.target.selector && annotation.target.selector.node) {
      // Pass the node object containing an id or index;
      nodeValue = annotation.target.selector.node;
    } // TODO: Possibly, though passed in values may be for different annotation type..
    // Or, there's an implied  limitation on providing upates for the same annotation type.
    // const coords = _merge({}, annotation.target.selector, coordinates);
    // If provided use to replace existing.


    var coords = coordinates || annotation.target.selector; // Target area is re-created.

    payload[PL.P_TARGET] = getACPTarget(annotation.target.source, nodeValue, coords);
  }

  return payload;
}
/**
 * Produces ACP payload for a new comment.
 *
 * @param   {string}  id           id of asset
 * @param   {string}  comment      comment text
 * @param   {string}  nodeId       node id (optional)
 * @param   {json}  coordinates    json payload for noteX,Y and sectionId (optional)
 * @param   {array}  mentions      array of json payload for id, name and type (optional)
 * @param   {string}  motivation   one of 'commenting' or 'replying'
 *
 * @return  {json}               json payload for comment api request
 */


function getCommentPayload(id, comment, nodeId, coordinates, mentions, motivation) {
  var annotationBody;

  if (_Client["default"].instance.isACP) {
    var _annotationBody;

    annotationBody = (_annotationBody = {}, _defineProperty(_annotationBody, PL.P_BODY, {
      'dc:format': 'text/plain',
      value: comment
    }), _defineProperty(_annotationBody, PL.P_MOTIVATION, motivation), _defineProperty(_annotationBody, PL.P_TARGET, {}), _annotationBody);
    annotationBody[PL.P_TARGET] = getACPTarget(id, nodeId, coordinates);
    annotationBody[PL.P_MENTIONS] = getACPMentions(mentions);
  } else {
    annotationBody = {
      '@context': ['https://www.w3.org/ns/anno.jsonld', 'https://comments.acrobat.com/ns/anno.jsonld'],
      type: 'Annotation',
      bodyValue: comment,
      motivation: motivation,
      target: {
        source: id
      }
    };

    if (mentions) {
      annotationBody.mentions = mentions;
    }

    if (isDefined(nodeId)) {
      // Set the target node id or index.
      setTargetNode(annotationBody, nodeId); // If this is an annotation, add the X/Y coordinates

      if (coordinates) {
        updateCoordinates(annotationBody, coordinates, false);
      }
    }
  }

  return annotationBody;
}